module.exports = __webpack_public_path__ + "77d21f34135aa605ef70d4ea0db936dd.jpg";